
<template>
  <div v-html="sysFooterDesc"></div>
</template>
<script>
import { getWebConfig } from '@frame/api/common/index'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      sysFooterDesc: ''
    }
  },
  created() {
    this.getDbWebConfig()
  },
  methods: {
    ...mapMutations(['setLoadFooterFlag']),
    getDbWebConfig() {
      // 获取页脚配置
      getWebConfig({ code: 'r_sys_footer' })
        .then(r => {
          if (r.data.success) {
            this.sysFooterDesc = r.data.value
            this.$nextTick(() => {
              this.setLoadFooterFlag()
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>

<style type="text/scss" scoped>
.footer {
  height: 50px;
  background-color: #1c232f;
  color: rgb(255, 255, 255);
  font-size: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
}
</style>